import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import IntlMessages from 'util/IntlMessages';

import styles from './styles.module.less';

const StepIndicator = ({
  currentStep,
  totalSteps,
  stepTitle,
  stepTitleId,
  stepTitles,
  stepCounterText,
  stepCounterId,
  stepCounterFormat,
  showStepCounter = true,
  layout = 'stacked',
  className,
}) => {
  const intl = useIntl();
  const progressPercentage = (currentStep / totalSteps) * 100;

  const isTranslationId = str => {
    return typeof str === 'string' && str.includes('.');
  };

  const getCurrentTitle = () => {
    if (stepTitles && Array.isArray(stepTitles)) {
      const title = stepTitles[currentStep - 1];
      if (title) {
        if (typeof title === 'string' && isTranslationId(title)) {
          return <IntlMessages id={title} />;
        }
        if (typeof title === 'string') {
          return title;
        }
        return title;
      }
    }

    if (stepTitleId) {
      return <IntlMessages id={stepTitleId} />;
    }

    if (typeof stepTitle === 'string') {
      return stepTitle;
    }

    if (stepTitle) {
      return stepTitle;
    }

    return null;
  };

  const renderTitle = () => {
    return getCurrentTitle();
  };

  const renderCounter = () => {
    if (!showStepCounter) {
      return null;
    }

    if (stepCounterText) {
      return <div className={styles.stepCounter}>{stepCounterText}</div>;
    }

    if (stepCounterId) {
      const formatValues = stepCounterFormat || { current: currentStep, total: totalSteps };
      return (
        <div className={styles.stepCounter}>
          {intl.formatMessage({ id: stepCounterId }, formatValues)}
        </div>
      );
    }

    return null;
  };

  const renderProgressBar = () => (
    <div className={styles.progressBar}>
      <div
        className={styles.progressFill}
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );

  if (layout === 'inline') {
    return (
      <div className={`${styles.stepIndicator} ${styles.inlineLayout} ${className || ''}`}>
        {renderProgressBar()}
        {renderCounter()}
      </div>
    );
  }

  return (
    <div className={`${styles.stepIndicator} ${className || ''}`}>
      <div className={styles.stepHeader}>
        <div className={styles.stepTitle}>{renderTitle()}</div>
        {renderCounter()}
      </div>
      {renderProgressBar()}
    </div>
  );
};

StepIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  stepTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  stepTitleId: PropTypes.string,
  stepTitles: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  ),
  stepCounterText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  stepCounterId: PropTypes.string,
  stepCounterFormat: PropTypes.object,
  showStepCounter: PropTypes.bool,
  layout: PropTypes.oneOf(['stacked', 'inline']),
  className: PropTypes.string,
};

export default StepIndicator;

